import { render, staticRenderFns } from "./BadgesDashboard.vue?vue&type=template&id=81812aa6&scoped=true"
import script from "./BadgesDashboard.vue?vue&type=script&lang=js"
export * from "./BadgesDashboard.vue?vue&type=script&lang=js"
import style0 from "./BadgesDashboard.vue?vue&type=style&index=0&id=81812aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81812aa6",
  null
  
)

export default component.exports